import { useAudioPlayer } from '../../audio-components/AudioProvider'
import { EpisodePlayButton } from '../../audio-components/EpisodePlayButton'
import { useState, useEffect } from 'react'

function PauseIcon(props) {
  return (
    <svg aria-hidden="true" viewBox="0 0 10 10" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.496 0a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5H2.68a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5H1.496Zm5.82 0a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5H8.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5H7.316Z"
      />
    </svg>
  )
}

function PlayIcon(props) {
  return (
    <svg aria-hidden="true" viewBox="0 0 10 10" {...props}>
      <path d="M8.25 4.567a.5.5 0 0 1 0 .866l-7.5 4.33A.5.5 0 0 1 0 9.33V.67A.5.5 0 0 1 .75.237l7.5 4.33Z" />
    </svg>
  )
}

function EpisodeEntry({ episode, isPlaying, onPlay, onPause }) {
  return (
    <article aria-labelledby={`song-${episode.id}-title`} className="py-6">
      <div className="flex flex-col items-start">
        <h2
          id={`song-${episode.id}-title`}
          className="mt-2 text-lg font-bold text-neutral-900"
        >
          {episode.title}
        </h2>
        <p className="mt-1 text-base leading-7 text-neutral-700">
          {episode.description}
        </p>
        <div className="mt-4 flex items-center gap-4">
          <EpisodePlayButton
            episode={episode}
            className="plausible-event-name=Play+Music flex items-center gap-x-3 text-sm font-bold leading-6 text-sv-crimson/80 hover:text-sv-crimson/70 active:text-sv-crimson/100"
            playing={
              <>
                <PauseIcon className="h-2.5 w-2.5 fill-current" />
                <span aria-hidden="true">Listen</span>
              </>
            }
            paused={
              <>
                <PlayIcon className="h-2.5 w-2.5 fill-current" />
                <span aria-hidden="true">Listen</span>
              </>
            }
            isPlaying={isPlaying}
            onPlay={() => onPlay(episode)}
            onPause={onPause}
          />
        </div>
      </div>
    </article>
  )
}

export const StudentMusic = () => {
  const { episodes, playNext, playPrevious } = useAudioPlayer()
  const [visibleEpisodes, setVisibleEpisodes] = useState(5) // Show first 5 episodes initially
  const [currentEpisode, setCurrentEpisode] = useState(null)
  const [audio, setAudio] = useState(null)
  const [currentEpisodeIndex, setCurrentEpisodeIndex] = useState(null)

  const handlePlay = (episode) => {
    if (audio) {
      audio.pause()
    }

    const newAudio = new Audio(episode.audio.src)
    newAudio.play()
    setAudio(newAudio)
    setCurrentEpisode(episode)
    setCurrentEpisodeIndex(episodes.findIndex((e) => e.id === episode.id))
  }

  const handlePause = () => {
    if (audio) {
      audio.pause()
    }
  }

  const showMoreEpisodes = () => {
    setVisibleEpisodes((prev) => prev + 5) // Show 5 more episodes when clicked
  }

  return (
    <>
      <div className="relative scroll-m-40" id="student-music">
        <div className="divide-y-2">
          {episodes.slice(0, visibleEpisodes).map((episode) => (
            <EpisodeEntry
              key={episode.id}
              episode={episode}
              isPlaying={currentEpisode?.id === episode.id && !audio?.paused}
              onPlay={handlePlay}
              onPause={handlePause}
              onPrevious={playPrevious}
              onNext={playNext}
            />
          ))}
        </div>

        {visibleEpisodes < episodes.length && (
          <div className="absolute inset-x-0 bottom-0 flex h-48 items-end justify-center">
            <div className="absolute -inset-x-4 bottom-0 flex h-40 items-end justify-center bg-white/70 backdrop-blur-sm [mask:linear-gradient(180deg,transparent_0%,black_80%)]"></div>
            <button
              onClick={showMoreEpisodes}
              className="relative rounded-full bg-sv-crimson py-2 px-4 text-sm text-white transition-colors hover:opacity-90"
            >
              Show More Music
            </button>
          </div>
        )}
      </div>
    </>
  )
}
